module.exports = __webpack_public_path__ + "static/media/rco-module.e29f31c6.svg";